export default (login) => {
  if (login.match(/^i:0/)) return 'sp'
  if (login.match(/^[^\\]+\\[^\\]+$/)) return 'ad'
  if (login.match(/^[^@]+@\S+$/)) return 'email'
  return null
}
